import axios from 'axios';

const baseURL = 'https://ucleanlaundry.com/api/v1'|| process.env.REACT_APP_BASE_URL;

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Existing franchise API
export const franchiseAPI = {
  submitFranchiseApplication: async (formData) => {
    try {
      const response = await apiClient.post(
        '/applyForFranchise',
        {
          fname: `${formData.firstName} ${formData.lastName}`,
          email: formData.email,
          mobile: formData.phone,
          city: formData.city,
          message: formData.message,
          lead_source: 'International website franchise form',
        },
        {
          params: {
            franchise: 'UCLEAN',
          },
        }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong',
      };
    }
  },
};

// New media API
export const mediaAPI = {
  getMedias: async () => {
    try {
      const response = await apiClient.get('/webusers/medias', {
        params: {
          franchise: 'UCLEAN',
        },
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong',
      };
    }
  },
};

// Existing event API
export const eventAPI = {
  submitEventRegistration: async (formData) => {
    try {
      const response = await apiClient.post(
        '/applyForFranchise',
        {
          fname: `${formData.firstName} ${formData.lastName}`,
          email: formData.email,
          mobile: formData.phone,
          city: formData.city, 
          message: `Selected consultation types: ${formData?.consultationTypes}`,
          lead_source: `Seminar registered for ${
            formData.consultationTypes}+${formData.countryCode}`,
        },
        {
          params: {
            franchise: 'UCLEAN',
          },
        }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong',
      };
    }
  },
};

export const servicesAPI = {
  getServices: async (franchise, cityId, storeId) => {
    try {
      const params = {
        franchise: franchise,
      };

      if (storeId) {
        params.store_id = storeId; // Prioritize storeId if provided
      } else {
        params.city_id = cityId;
      }

      const response = await apiClient.get('/webusers/services', {
        params: params,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong',
      };
    }
  },
};

export const pricingAPI = {  // Added pricingAPI
  getPricing: async (franchise, cityId, serviceIds, storeId) => {
    try {
      const params = {
        franchise: franchise,
        city_id: cityId,
        service_ids: serviceIds, // expects a string
      };

      if (storeId) {
        params.store_id = storeId;
      }

      const response = await apiClient.get('/webusers/pricing', {
        params: params,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong',
      };
    }
  },
};

export const citiesAPI = {
  getCities: async (countryCode, lang = 'en') => {
    try {
      const response = await apiClient.get('/cities', {
        params: {
          franchise: 'UCLEAN',
          lang: lang, // Language parameter
          countryCode: countryCode, // Country code parameter
        },
      });

      return {
        success: true,
        data: response.data.cities, // Return the cities array
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong', // Handle errors gracefully
      };
    }
  },
};

// Stores API
export const storesAPI = {
 getStores: async (countryCode, cityId = null) => {
    try {
      const params = {
        countryCode: countryCode, // Country code parameter
        franchise: 'UCLEAN',      // Franchise parameter
        lang: 'ar',               // Add lang parameter
      };

      if (cityId) {
        params.city_id = cityId; // Add city_id if provided
      }

      const response = await apiClient.get('/webusers/stores', { params });

      return {
        success: true,
        data: response.data, // Return API response data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong', // Handle errors gracefully
      };
    }
  },

  getStoreDetails: async (storecode) => {
    try {
      const response = await apiClient.get('/storesaddress/details', {
        params: {
          franchise: 'UCLEAN',
          cityStoreLoc: storecode,
        },
      });

      return {
        success: true,
        data: response.data.store, // Return the store details
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Something went wrong', // Handle errors gracefully
      };
    }
  },
};

export default apiClient;
